import { render, staticRenderFns } from "./sharePoster.vue?vue&type=template&id=2fbb7a27&scoped=true&"
import script from "./sharePoster.vue?vue&type=script&lang=js&"
export * from "./sharePoster.vue?vue&type=script&lang=js&"
import style0 from "./sharePoster.vue?vue&type=style&index=0&id=2fbb7a27&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fbb7a27",
  null
  
)

export default component.exports